import 'katex/dist/katex.min.css';
import '@/App.css';
import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@/context/ThemeContext';
import Layout from '@/components/Layout';
import Home from '@/pages/Home';
import PerUnitModule from '@/pages/PerUnitModule';
import FoundationModule from '@/pages/FoundationModule';
import TransformerModule from '@/pages/TransformerModule';
import SymmetricalComponentsModule from '@/pages/SymmetricalComponentsModule';
import SequenceNetworksModule from '@/pages/SequenceNetworksModule';
import ModuleStub from '@/pages/ModuleStub';
import CalculatorsHub from '@/pages/CalculatorsHub';
import AboutPage from '@/pages/AboutPage';

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/per-unit" element={<PerUnitModule />} />
            <Route path="/foundation" element={<FoundationModule />} />
            <Route path="/transformers" element={<TransformerModule />} />
            <Route path="/symmetrical-components" element={<SymmetricalComponentsModule />} />
            <Route path="/sequence-networks" element={<SequenceNetworksModule />} />
            <Route path="/fault-analysis" element={<ModuleStub moduleId="fault-analysis" />} />
            <Route path="/protection" element={<ModuleStub moduleId="protection" />} />
            <Route path="/distribution-design" element={<ModuleStub moduleId="distribution-design" />} />
            <Route path="/calculators" element={<CalculatorsHub />} />
            <Route path="/about" element={<AboutPage />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
